import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const InfoMaterial = (props) => (
  <Icon viewBox="0 0 36 36" {...props}>
    <g>
      <path d="M17.4 26h1.8v-2.3h-1.8V26zm-2.5-10.9c0-.6.1-1.1.2-1.6s.4-.9.7-1.3c.3-.4.7-.6 1.1-.8.4-.2 1-.3 1.6-.3.4 0 .8.1 1.2.2.4.1.7.3 1 .6.3.3.5.6.7.9.2.4.3.8.3 1.2 0 .6-.1 1.1-.4 1.6-.3.5-.6.9-1 1.3-.5.4-.9.8-1.2 1.1-.3.3-.6.7-.8 1-.2.4-.4.8-.4 1.2-.1.5-.1 1-.1 1.7H19c0-.7 0-1.2.1-1.5 0-.4.1-.7.3-.9.1-.3.3-.5.6-.8.3-.2.6-.6 1.1-1.1.6-.5 1-1.1 1.4-1.6.4-.6.5-1.3.5-2.1 0-.6-.1-1.2-.4-1.7-.2-.5-.6-.9-1-1.3s-.9-.6-1.4-.8c-.5-.2-1.1-.3-1.7-.3-.8 0-1.5.1-2.1.4-.6.2-1.1.6-1.6 1-.4.4-.7 1-1 1.6-.2.6-.3 1.3-.3 2.1h1.4z"
        className="st0" />
      <path d="M18 36C8.1 36 0 27.9 0 18S8.1 0 18 0s18 8.1 18 18-8.1 18-18 18zm0-35C8.6 1 1 8.6 1 18s7.6 17 17 17 17-7.6 17-17S27.4 1 18 1z" className="st0" />
    </g>
  </Icon>
);
/*eslint-enable */

export default InfoMaterial;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/InfoMaterial.js